module.exports = __webpack_public_path__ + "static/media/dp2.35b93f83.jpg";